import React, { FC, useEffect, useState } from 'react';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { SCUIButton, SCUILoadingLinear, SCUINoRecordComponent } from '../../atomic/atoms';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { PageUrlRs } from '../../types/enums';
import { Box, Grid, Tooltip } from '@mui/material';
import airdropShipment from '../../assets/icons/svg/pageIcons/airdropShipment.svg';
import { useTranslation } from 'react-i18next';
import { FiscalDrawer } from './FiscalDrawer';
import { PostCheckoutQuery } from '../../services/query';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TimeHelper from '../../utils/time';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import IconButton from '@mui/material/IconButton';

export const FiscalPage: FC<any> = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        right: false,
    });
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [fiscalType, setFiscalType] = useState<any>();
    const [datas, setDatas] = useState<any>([]);
    const [selectedRowsForDownload, setSelectedForDownload] = useState<any[]>([]);
    const [count, setCount] = useState<any>(0);
    const [isShow, setIsShow] = useState<boolean>(false);
    const [formData, setFormData] = useState({
        orderNumber: '',
        fiscalType: null as number | null,
        startDate: '',
        endDate: '',
        email: '',
        uuid: '',
        referenceUuid: '',
    });
    const GetFiscalType = async () => {
        PostCheckoutQuery.GetFiscalType().then((res: any) => {
            if (res?.data) {
                setFiscalType(res.data);
            }
        });
    };
    const createPdfBlobUrl = (base64String: string): string => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        return URL.createObjectURL(blob);
    };
    const openPdfFromBase64 = (base64String: string) => {
        const pdfBlobUrl = createPdfBlobUrl(base64String);
        window.open(pdfBlobUrl, '_blank', 'noopener,noreferrer');
    };
    const FiscalSearch = async (pageNumberReq?: any, pageSizeReq?: any) => {
        setIsShow(true);
        setIsLoading(true);
        let params = null;
        params = {
            orderNumber: formData.orderNumber,
            fiscalType: formData.fiscalType,
            startDate: formData.startDate,
            endDate: formData.endDate,
            email: formData.email,
            uuid: formData.uuid,
            referenceUuid: formData.referenceUuid,
            page: pageNumberReq + 1,
            take: pageSizeReq,
        };
        if (formData?.startDate && formData?.fiscalType) {
            PostCheckoutQuery.GetFiscalList(params)
                .then((res: any) => {
                    setCount(res?.totalCount);
                    let parseData = res?.data?.map((item: any) => {
                        return {
                            id: item.id,
                            date: item.date,
                            orderNumber: item.orderNumber,
                            paymentMethod: item.paymentMethod,
                            email: item.email || '-',
                            fiscalInvoiceNumber: item.fiscalInvoiceNumber,
                            grandTotalExcludingTax: item.grandTotalExcludingTax.toFixed(2) + ' ' + item.currencySymbol,
                            grandTotal: item.grandTotal.toFixed(2) + ' ' + item.currencySymbol,
                            itemsQuantity: item.itemsQuantity,
                            uuid: item.uuid || '-',
                            referenceUUID: item.referenceUUID || '-',
                        };
                    });
                    if (res.data?.length === 0) {
                        Swal.fire(t('general.noDataFound'), ' ', 'error');
                    }
                    setSelectedForDownload(
                        res.data.map((item: any) => ({
                            [t('general.date')]: TimeHelper.formatDateHour(item.date),
                            [t('general.orderNo')]: item.orderNumber,
                            [t('general.paymentType')]: item.paymentMethod || '-',
                            [t('general.eMail')]: item.email || '-',
                            [t('fiscal.receiptNo')]: item.fiscalInvoiceNumber,
                            [t('general.cost')]: item.grandTotalExcludingTax.toFixed(2) + ' ' + item.currencySymbol,
                            [t('fiscal.amountVAT')]: item.grandTotal.toFixed(2) + ' ' + item.currencySymbol,
                            [t('general.quantity')]: item.itemsQuantity,
                            UUID: item.uuid || '-',
                            [t('fiscal.referenceUUID')]: item.referenceUUID || '-',
                        }))
                    );
                    setDatas(parseData);
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
            Swal.fire(t('lcwMoney.noEmpty'), ' ', 'error');
        }
    };
    const handleDownloadPdf = async (id: any) => {
        let params = null;
        params = {
            fiscalizationId: id,
        };
        PostCheckoutQuery.GetFiscal(params)
            .then((res: any) => {
                if (res?.data?.qrCode) {
                    openPdfFromBase64(res.data.qrCode);
                } else {
                    window.open(res.data.verificationUrl, '_blank', 'noopener,noreferrer');
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    useEffect(() => {
        GetFiscalType();
    }, []);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'date',
            headerName: t('general.date'),
            width: 120,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return <>{TimeHelper.formatDateHour(params.row.date)}</>;
            },
        },
        {
            field: 'orderNumber',
            headerName: t('general.orderNo'),
            width: 120,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'paymentMethod',
            headerName: t('general.paymentType'),
            width: 120,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        { field: 'email', headerName: t('general.eMail'), width: 180, flex: 1, headerAlign: 'center', align: 'center' },
        {
            field: 'fiscalInvoiceNumber',
            headerName: t('fiscal.receiptNo'),
            width: 130,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.fiscalInvoiceNumber}>
                            <p>{params.row.fiscalInvoiceNumber}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'grandTotalExcludingTax',
            headerName: t('general.cost'),
            width: 100,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return <span>{params.row.grandTotalExcludingTax}</span>;
            },
        },
        {
            field: 'grandTotal',
            headerName: t('fiscal.amountVAT'),
            width: 130,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return <span>{params.row.grandTotal}</span>;
            },
        },
        {
            field: 'itemsQuantity',
            headerName: t('general.quantity'),
            width: 80,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'uuid',
            headerName: 'UUID',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value !== '-' ? `${params?.value?.slice(0, 8)}...` : params?.value}</span>
                </Tooltip>
            ),
            flex: 1,
        },
        {
            field: 'referenceUUID',
            headerName: t('fiscal.referenceUUID'),
            width: 170,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value !== '-' ? `${params?.value?.slice(0, 8)}...` : params?.value}</span>
                </Tooltip>
            ),
            flex: 1,
        },
        {
            field: 'downloadPdf',
            headerName: t('fiscal.document'),
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <IconButton
                    color="primary"
                    onClick={() => {
                        handleDownloadPdf(params.row.id);
                    }}
                >
                    <PictureAsPdfIcon />
                </IconButton>
            ),
            flex: 1,
        },
    ];

    return (
        <SCUIContent>
            <SCUIBreadCrumb
                title={t('fiscal.fiscalTitle')}
                componentLink={PageUrlRs.fiscalPage.url}
                onClick={() => {
                    setDatas(null);
                    setIsShow(false);
                }}
            />
            <Grid
                sx={{ padding: '1rem' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                {' '}
                {<SCUILoadingLinear display={isLoading} />}
            </Grid>
            <SCUIGeneralDrawer
                open={state['right']}
                anchor="right"
                width={'40rem'}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setState({ ...state, right: false });
                    }
                }}
            >
                <FiscalDrawer
                    formData={formData}
                    onCloseMenu={onDrawerClose}
                    setFormData={setFormData}
                    fiscalType={fiscalType}
                    fiscalSearch={FiscalSearch}
                    setPageNumber={setPageNumber}
                    pageSize={pageSize}
                />
            </SCUIGeneralDrawer>
            {isShow ? (
                <>
                    <Grid
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                        size={{
                            xl: 4,
                            lg: 4,
                            md: 4,
                            xs: 4,
                        }}
                    >
                        <SCUIButton
                            text={t('general.detailedSearch')}
                            onClick={onDrawerOpen}
                            buttonType="button"
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            style={{ width: '150px', marginBottom: '16px', marginLeft: 'auto' }}
                        />
                    </Grid>
                    <Grid
                        size={{
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <SCUICustomDataGrid
                            randomId
                            rows={datas}
                            columns={columns}
                            excelDownloadButton={true}
                            excelDownloadData={selectedRowsForDownload}
                            excelDownloadFolderName={t('fiscal.fiscalTitle')}
                            onPageSizeChange={(i: number) => {
                                setPageSize(i);
                                setPageNumber(0);
                                FiscalSearch(0, i);
                            }}
                            onPageChange={(i: number) => {
                                setPageNumber(i);
                                FiscalSearch(i, pageSize);
                            }}
                            page={pageNumber}
                            pageSize={pageSize}
                            rowCount={count}
                            paginationModeChange
                        />
                    </Grid>
                </>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <SCUINoRecordComponent img={airdropShipment} />
                    <SCUIButton
                        style={{ width: '100px', marginTop: '16px' }}
                        text={t('general.search')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            onDrawerOpen();
                        }}
                    />
                </Box>
            )}
        </SCUIContent>
    );
};
